<template>
  <div class="text-center">
    <v-badge
      :color="colorBadge"
      overlap
    >
      <template v-slot:badge>
        <span
          v-if="validarInicial"
          class="font-weight-medium"
          style="color: #000"
        >
          {{ valorBadge }}
        </span>
      </template>

      <v-btn color='primary' small @click="dialog = true">
        <span v-if="validarInicial > 0 && countDesserts.count > 0 || itemSelecionado.length > 0">
          <v-icon left>mdi-refresh</v-icon>
          Atualizar
        </span>
        <span v-else>
          <v-icon left>mdi-plus</v-icon>
          Novo
        </span>
      </v-btn>
    </v-badge>

    <!-- <sys-dialog
      v-model="dialog"
      :titulo="tituloDinamico"
      :largura="650"
      @click:primary="editando ? editarSazonalidade() : salvarSazonalidade()"
      @click:hidden-dialog="fechar()"
      txtBotao="Salvar"
    >
      <sys-fornecedor-autocomplete
        v-if="!editando"
        v-model="itensForm.fornecedores"
        label="Fornecedor"
        outlined
        clearable
        multiple
        desativarSelecionarTodos
        :qtdeVisivelSelecionados="10"
        :error-messages="fornecedoresErrors"
        @input="$v.itensForm.fornecedores.$touch()"
        @blur="$v.itensForm.fornecedores.$touch()"
      ></sys-fornecedor-autocomplete>

      <v-switch
        v-show="!editando"
        v-model="selecionarProdutos"
        class="ml-n2"
      >
        <template v-slot:label>
          <span class="ml-2">
            {{ txtSwitchTodosProdutos }}
          </span>
        </template>
      </v-switch>
      <template v-if="!selecionarProdutos && dialog">
        <sys-produto-autocomplete
          v-model="itensForm.idproduto"
          label="Produtos"
          :disabled="editando"
          outlined
          multiple
          small-chips
          :force-busca="verificaIdprodutoAutocomplete"
          class="max-height-body-autocomplee-150"
          :fornecedores="itensForm.fornecedores"
          :error-messages="produtoErrors"
          @input="$v.itensForm.idproduto.$touch()"
          @blur="$v.itensForm.idproduto.$touch()"
        ></sys-produto-autocomplete>
      </template>

      <div class="d-flex" v-if="showMultiplosPeriodos.length > 0">
        <v-col cols="12" class="ml-0 pl-0 mt-0 pt-0 mt-n2">
          <span>Periodos Selecionados: </span>

          <p
            v-for="(dado, idx) in showMultiplosPeriodos"
            :key="idx"
            class="ma-0 pa-0"
          >
            <span>{{ dado[0] }} à {{ dado[1] }}</span>
            <v-btn
              icon
              small
              class="ma-0 pa-0"
              @click="removerMultiploPeriodo(idx)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </p>
        </v-col>
      </div>

      <div class="d-flex">
        <v-menu
          ref="menuDataInicial"
          v-model="menuDataInicial"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="itensForm.dataInicialPeriodo"
              label="Data do Inicio do Período"
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              outlined
              :error-messages="showMultiplosPeriodosErrors.length > 0 ? showMultiplosPeriodosErrors : dataInicialPeriodoErrors"
              @input="$v.itensForm.dataInicialPeriodo.$touch()"
              @blur="dataInicial = parseDate(itensForm.dataInicialPeriodo); $v.itensForm.dataInicialPeriodo.$touch()"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="dataInicial"
            no-title
            @input="menuDataInicial = false"
          ></v-date-picker>
        </v-menu>

        <v-menu
          ref="menuDataFinal"
          v-model="menuDataFinal"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="itensForm.dataFinalPeriodo"
              label="Data do Final do Período"
              v-bind="attrs"
              v-on="on"
              outlined
              class="ml-2"
              :error-messages="showMultiplosPeriodosErrors.length > 0 ? showMultiplosPeriodosErrors : dataFinalPeriodoErrors"
              @input="$v.itensForm.dataFinalPeriodo.$touch()"
              @blur="dataFinal = parseDate(itensForm.dataFinalPeriodo); $v.itensForm.dataFinalPeriodo.$touch()"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="dataFinal"
            no-title
            @input="menuDataFinal = false"
          ></v-date-picker>
        </v-menu>

        <v-btn
          class="ml-2 mt-2"
          icon
          @click="multiplosPeriodos()"
        >
          <v-icon>mdi-plus</v-icon>
          </v-btn>
      </div>

      <div class="row">
        <div class="col-md-6 pr-2">
          <v-select
            v-model="itensForm.tipoAjuste"
            :items="items_select"
            item-text="text"
            item-value="value"
            label="Tipo de Ajuste"
            outlined
            :error-messages="tipoAjusteErrors"
            @input="$v.itensForm.tipoAjuste.$touch()"
            @blur="$v.itensForm.tipoAjuste.$touch()"
          ></v-select>
        </div>

        <div class="col-md-6 pl-2">
          <text-field-formatador-de-valor
            v-model="itensForm.porcentagem"
            label="Porcentagem de Crescimento"
            prefix="%"
            outlined
            @focus="$event.target.select()"
            :error-messages="porcentagemErrors"
            @input="$v.itensForm.porcentagem.$touch()"
            @blur="$v.itensForm.porcentagem.$touch()"
          ></text-field-formatador-de-valor>
        </div>
      </div>

      <v-checkbox v-model="itensForm.recorrencia" class="ml-n2">
        <template v-slot:label>
          <span class="ml-2">Item recorrente?</span>
        </template>
      </v-checkbox>
    </sys-dialog> -->
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from "vuex";
  import moment from 'moment';
  import { required } from "vuelidate/lib/validators";
  import SazonalidadeAPI from "../../../api/sazonalidade";
  import SysDialog from "../../padraoDeLayout/SysDialog.vue";
  import TextFieldFormatadorDeValor from '../../utils/TextFieldFormatadorDeValor.vue';
  import SysProdutoAutocomplete from "../../utils/crud/SysProdutoAutocomplete"
  import SysFornecedorAutocomplete from "../../utils/crud/SysFornecedorAutocomplete"

  export default {
    components: {
      SysDialog,
      TextFieldFormatadorDeValor,
      SysProdutoAutocomplete,
      SysFornecedorAutocomplete
    },

    props: {
      editedItem: {
        type: [Array, Object]
      },

      itemSelecionado: {
        type: [Array, Object]
      },

      alterarBotao: {
        type: Boolean,
        default: false
      },

      abrirDialogProdutoParaCadastro: {
        type: Boolean,
        default: false
      },

      produtoTelaCompra: {
        type: [Object, Array]
      },

      openDialogNovaSazonalidade: {
        type: Boolean
      },

      countDesserts: {
        type: Object,
        default: {}
      },

    },

    data: () => ({
      dialog: false,
      editando: false,
      selectProdutos: [],
      dataInicial: '',
      dataFinal: '',
      menuDataInicial: false,
      menuDataFinal: false,
      itensForm: {
        fornecedores: [],
        idproduto: [],
        dataInicialPeriodo: null,
        dataFinalPeriodo: null,
        porcentagem: '',
        recorrencia: false,
        tipoAjuste: ''
      },
      items_select: [
        { text: 'Aumento', value: '1'},
        { text: 'Redução', value: '0'}
      ],
      selecionarProdutos: false,
      oldIdProdutos: [],
      showMultiplosPeriodos: []
    }),

    validations: {
      itensForm: {
        fornecedores: {
          required: function () {
            if (!this.selecionarProdutos) {
              return true;
            }

            return this.itensForm.fornecedores && this.itensForm.fornecedores.length > 0
          }
        },

        idproduto: {
          required: function () {
            if (this.selecionarProdutos) {
              return true;
            }

            return this.itensForm.idproduto && this.itensForm.idproduto.length > 0
          }
        },

        dataInicialPeriodo: {
          required() {
            return this.showMultiplosPeriodos.length > 0 || !!this.itensForm.dataInicialPeriodo;
          },
          validaData() {
            const inicial = moment(this.itensForm.dataInicialPeriodo, 'DD/MM/YYYY');
            const final = moment(this.itensForm.dataFinalPeriodo, 'DD/MM/YYYY');

            return this.showMultiplosPeriodos.length > 0 || !(final < inicial);
          }
        },

        dataFinalPeriodo: {
          required() {
            return this.showMultiplosPeriodos.length > 0 || !!this.itensForm.dataFinalPeriodo;
          },
          validaData() {
            const inicial = moment(this.itensForm.dataInicialPeriodo, 'DD/MM/YYYY');
            const final = moment(this.itensForm.dataFinalPeriodo, 'DD/MM/YYYY');

            return this.showMultiplosPeriodos.length > 0 || !(final < inicial);
          }
        },

        recorrencia: { required },
        porcentagem: { required },
        tipoAjuste: { required },
      },
      showMultiplosPeriodos: {
        validador() {
          return this.showMultiplosPeriodos.length == 0 ? false : true;
        }
      }
    },

    computed: {
      ...mapGetters({
        grupo_id: "usuario/getGrupoCompras",
        getFornecedor: "fornecedor/getFornecedor",
        produtosSelecionadosVuex: "ProdutosSelecionados/getProdutosSelecionados",
        qtdeProdutosSelecionadosVuex: "ProdutosSelecionados/getQtdeProdutosSelecionados"
      }),

      verificaIdprodutoAutocomplete() {
        if (this.editedItem && this.editedItem.idproduto) {
          return [this.editedItem.idproduto];
        } else if (this.itensForm && this.itensForm.idproduto) {
          return this.itensForm.idproduto;
        }
        return [];
      },

      tituloDinamico() {
        if (this.editando && this.editedItem.filial) {
          return 'Edição de Produto Sazonal - Filial ' + this.editedItem.filial;
        } else if (this.editando) {
          return 'Edição de Produto Sazonal';
        } else if (this.qtdeProdutosSelecionadosVuex > 0) {
          return 'Atualizar Produtos Sazonais';
        } else {
          return 'Cadastro de Produto Sazonal';
        }
      },

      validarInicial() {
        return (this.qtdeProdutosSelecionadosVuex > 0 && this.$route.path != '/produtos/sazonalidades') || (this.itemSelecionado.length > 0);
      },

      valorBadge() {
        return this.qtdeProdutosSelecionadosVuex > 0 ? this.qtdeProdutosSelecionadosVuex : this.itemSelecionado.length > 0 ? this.itemSelecionado.length : '';
      },

      colorBadge() {
        return this.validarInicial ? '#FFF' : '';
      },

      fornecedoresErrors() {
        const errors = [];
        if (!this.$v.itensForm.fornecedores.$dirty) return errors;
        !this.$v.itensForm.fornecedores.required && errors.push("Campo Obrigatório.");
        return errors;
      },

      produtoErrors() {
        const errors = [];
        if (!this.$v.itensForm.idproduto.$dirty) return errors;
        !this.$v.itensForm.idproduto.required && errors.push("Campo Obrigatório.");
        return errors;
      },

      dataInicialPeriodoErrors() {
        const errors = [];
        if (this.showMultiplosPeriodos.length > 0 || !this.$v.itensForm.dataInicialPeriodo.$dirty) return errors;
        !this.$v.itensForm.dataInicialPeriodo.required && errors.push("Campo Obrigatório.");
        !this.$v.itensForm.dataInicialPeriodo.validaData && errors.push("Data inicial não pode der maior que a data final!");
        return errors;
      },

      dataFinalPeriodoErrors() {
        const errors = [];
        if ( this.showMultiplosPeriodos.length > 0 || !this.$v.itensForm.dataFinalPeriodo.$dirty) return errors;
        !this.$v.itensForm.dataFinalPeriodo.required && errors.push("Campo Obrigatório.");
        !this.$v.itensForm.dataFinalPeriodo.validaData && errors.push("Data Final não pode der menor que a data inicial!");
        return errors;
      },

      showMultiplosPeriodosErrors() {
        const errors = [];
        if (this.showMultiplosPeriodos.length > 0 || !this.$v.showMultiplosPeriodos.$dirty) return errors;
        !!this.$v.showMultiplosPeriodos.validador && errors.push("Os campos são obrigatórios.");
        return errors;
      },

      tipoAjusteErrors() {
        const errors = [];
        if (!this.$v.itensForm.tipoAjuste.$dirty) return errors;
        !this.$v.itensForm.tipoAjuste.required && errors.push("Campo Obrigatório.");
        return errors;
      },

      porcentagemErrors() {
        const errors = [];
        if (!this.$v.itensForm.porcentagem.$dirty) return errors;
        !this.$v.itensForm.porcentagem.required && errors.push("Campo Obrigatório.");
        return errors;
      },

      txtSwitchTodosProdutos() {
        let txt = 'Selecionar todos os Produtos do'

        if (!this.itensForm.fornecedores || this.itensForm.fornecedores.length <= 1) {
          return `${txt} Fornecedor`
        }

        return `${txt}s Fornecedores`
      }
    },

    mounted() {
      setTimeout(() => {
        if (this.$route.path == '/compra') {
          this.dialog = this.qtdeProdutosSelecionadosVuex > 0 && !this.openDialogNovaSazonalidade;
        }
      }, 2000);
    },

    watch: {
      itemSelecionado(val) {
        if (val.length > 0) {
          val.forEach(e => {
            let values = val.map(function(v, i) {
              return v.idproduto;
            });
            this.itensForm.idproduto = values;
          });
        } else {
          this.itensForm.idproduto = [];
        }
      },

      openDialogNovaSazonalidade(val) {
        this.dialog = val && this.qtdeProdutosSelecionadosVuex > 0;
      },

      abrirDialogProdutoParaCadastro(val) {
        if (val) {
          this.itensForm.idproduto = [];
          this.itensForm.fornecedores = [];

          this.itensForm.fornecedores = this.produtoTelaCompra.fornecedor;
          this.itensForm.idproduto = this.produtoTelaCompra.produto;
        }
      },

      dialog(val) {
        if (this.$route.path == '/compra' && !this.editando && !!val) {
          if (this.qtdeProdutosSelecionadosVuex > 1) {
            this.limparCamposDialog();
            this.produtoMulti();
          }
          else if (this.countDesserts.count == 1 && this.qtdeProdutosSelecionadosVuex == 1) {
            this.produtoSingle();
          }
          else if (this.qtdeProdutosSelecionadosVuex == 1) {
            this.itensForm.fornecedores = [this.produtosSelecionadosVuex[0].idfornecedor];
            this.itensForm.idproduto = [this.produtosSelecionadosVuex[0].idproduto];
          }
          else {
            this.itensForm.fornecedores = [this.getFornecedor.id];
          }
        }
      },

      countDesserts(val) {
        if (this.qtdeProdutosSelecionadosVuex == 1 && this.dialog && val.count > 0) {
          val.dados.forEach(e => {
            this.itensForm.fornecedores = [e.idfornecedor];
            this.itensForm.idproduto = [e.idproduto];

            this.showMultiplosPeriodos.push([
              JSON.parse(e.dia_mes_inicial)[0] + '/' + moment().year(),
              JSON.parse(e.dia_mes_final)[0] + '/' + moment().year()
            ]);

            let validate = e.porcentagem_filial == e.porcentagem ;
            this.itensForm.porcentagem = validate ? e.porcentagem : e.porcentagem_filial;

            this.itensForm.recorrencia = e.recorrencia = '0' ? false : true;
            this.itensForm.tipoAjuste = e.tipo_ajuste;
          });
        } else if (this.qtdeProdutosSelecionadosVuex == 1) {
          this.limparCamposDialog();
          this.itensForm.fornecedores = [this.getFornecedor.id];
          this.itensForm.idproduto = this.qtdeProdutosSelecionadosVuex > 0 ?  [this.produtosSelecionadosVuex[0].idproduto] : [];
        }
      },

      selecionarProdutos(val) {
        if (val) {
          this.oldIdProdutos = this.itensForm.idproduto;
        } else {
          this.itensForm.idproduto = this.oldIdProdutos;
        }
      },

      editedItem(val) {
        if (val) {
          this.dialog = true;
          this.editando = true;

          JSON.parse(val.dia_mes_inicial).forEach((e, idx) => {
            this.showMultiplosPeriodos.push([
              e + '/' + moment().year(),
              JSON.parse(val.dia_mes_final)[idx] + '/' + moment().year()
            ]);
          });

          this.itensForm = {
            fornecedores: [],
            grupo_id: this.grupo_id,
            filial: val.filial,
            dataInicialPeriodo: null,
            dataFinalPeriodo: null,
            idproduto: [val.idproduto],
            porcentagem: val.porcentagem,
            recorrencia: val.recorrencia == '1' ? true : false,
            tipoAjuste: val.tipo_ajuste == '1' ? '1' : '0'
          }
        } else {
          this.editando = false;
        }
      },

      dataInicial (val) {
        this.itensForm.dataInicialPeriodo = this.formatDate(val);
      },

      dataFinal (val) {
        this.itensForm.dataFinalPeriodo = this.formatDate(val);
      },
    },

    methods: {
      ...mapMutations({
        resetProdutosSelecionados: "ProdutosSelecionados/SET_RESET_PRODUTOS_SELECIONADOS",
        fecharDialogSazonalidade: "tabelaProduto/SET_FECHAR_DIALOG_SAZONALIDADE"
      }),

      produtoSingle() {
        if (this.countDesserts.count == 1 && this.qtdeProdutosSelecionadosVuex == 1) {
          this.itensForm.fornecedores = [this.countDesserts.dados[0].idfornecedor];
          this.itensForm.idproduto = [this.countDesserts.dados[0].idproduto];

          JSON.parse(this.countDesserts.dados[0].dia_mes_inicial).forEach((e, idx) => {
            this.showMultiplosPeriodos.push([
              e + '/' + moment().year(),
              JSON.parse(this.countDesserts.dados[0].dia_mes_final)[idx] + '/' + moment().year()
            ]);
          });

          let validate = this.countDesserts.dados[0].porcentagem_filial == this.countDesserts.dados[0].porcentagem ;
          this.itensForm.porcentagem = validate ? this.countDesserts.dados[0].porcentagem : this.countDesserts.dados[0].porcentagem_filial;

          this.itensForm.recorrencia = this.countDesserts.dados[0].recorrencia;
          this.itensForm.tipoAjuste = this.countDesserts.dados[0].tipo_ajuste;
        } else if (this.qtdeProdutosSelecionadosVuex > 0) {
          this.itensForm.fornecedores = [this.getFornecedor.id];
          this.itensForm.idproduto = [this.produtosSelecionadosVuex[0].idproduto];
        }
      },

      produtoMulti() {
        if (this.qtdeProdutosSelecionadosVuex > 1 && !this.itensForm.fornecedores.includes(this.produtosSelecionadosVuex[0])) {
          this.itensForm.fornecedores.push(this.produtosSelecionadosVuex[0].idfornecedor);
        }
        this.produtosSelecionadosVuex.forEach(el => {
          if (!this.itensForm.idproduto.includes(el.idproduto)) {
            this.itensForm.idproduto.push(el.idproduto);
          }
        });
      },

      limparCamposDialog() {
        this.itensForm.filial = "";
        this.itensForm.fornecedores = [];
        this.itensForm.idproduto = [];
        this.itensForm.dataInicialPeriodo = null;
        this.itensForm.dataFinalPeriodo = null;
        this.itensForm.porcentagem = '';
        this.itensForm.recorrencia = false;
        this.itensForm.tipoAjuste = '';
        this.showMultiplosPeriodos = [];
        this.dataInicial = '';
        this.dataFinal = '';
      },

      emits() {
        this.$emit('limpar-edited-item');
        this.$emit('atualizar-data-table');
      },

      fechar() {
        this.dialog = false;
        this.selecionarProdutos = false;
        this.emits();
        this.limparCamposDialog();
        this.$v.$reset();
      },

      salvarSazonalidade() {
        this.$v.$touch();

        this.adicionarData();

        if (!this.$v.$invalid) {
          const headers = this.Helpers.iniciarRequisicao();
          const params = {
            id_grupo: this.grupo_id,
            fornecedores: this.itensForm.fornecedores,
            idproduto: this.itensForm.idproduto,
            porcentagem: this.itensForm.porcentagem,
            recorrencia: this.itensForm.recorrencia,
            tipo_ajuste: this.itensForm.tipoAjuste,
            todosProdutosDoFornecedor: this.selecionarProdutos,
            show_multiplos_periodos: this.showMultiplosPeriodos
          }

          this.$store.dispatch(
            "loading/addRequisicao",
            SazonalidadeAPI.storeSazonalidade(headers, params)
              .then((response) => {
                const { token } = response.data;
                localStorage.setItem("token", token);

                // this.fechar();
                // this.resetProdutosSelecionados();
                // this.fecharDialogSazonalidade();
              })
              .catch(() => {
                this.Helpers.logout();
              })
          );
        }
      },

      adicionarData() {
        if (!!this.itensForm.dataInicialPeriodo && !!this.itensForm.dataFinalPeriodo) {
          this.showMultiplosPeriodos.push([this.itensForm.dataInicialPeriodo, this.itensForm.dataFinalPeriodo]);

          this.itensForm.dataInicialPeriodo == null;
          this.itensForm.dataFinalPeriodo == null;
          this.dataInicial = '';
          this.dataFinal = '';
        }
      },

      editarSazonalidade() {
        this.$v.$touch();

        this.adicionarData();

        if (!this.$v.$invalid) {
          const headers = this.Helpers.iniciarRequisicao();
          const params = {
            id: this.editedItem.id,
            id_grupo: this.grupo_id,
            filial: this.editedItem.filial,
            idproduto: this.itensForm.idproduto,
            porcentagem: this.itensForm.porcentagem,
            recorrencia: this.itensForm.recorrencia,
            tipo_ajuste: this.itensForm.tipoAjuste,
            show_multiplos_periodos: this.showMultiplosPeriodos
          }

          this.$store.dispatch(
            "loading/addRequisicao",
            SazonalidadeAPI.storeSazonalidade(headers, params)
              .then((response) => {
                const { token } = response.data;
                localStorage.setItem("token", token);

                // this.fechar();
                // this.resetProdutosSelecionados();
                // this.fecharDialogSazonalidade();
              })
              .catch(() => {
                this.Helpers.logout();
              })
          );
        }
      },

      multiplosPeriodos() {
        if (
          this.itensForm.dataInicialPeriodo != null
          && this.itensForm.dataFinalPeriodo != null
          && this.itensForm.dataInicialPeriodo < this.itensForm.dataFinalPeriodo
        ) {
          this.showMultiplosPeriodos.push([this.itensForm.dataInicialPeriodo, this.itensForm.dataFinalPeriodo]);
          this.itensForm.dataInicialPeriodo = null;
          this.itensForm.dataFinalPeriodo = null;
        }
      },

      removerMultiploPeriodo(idx){
        this.showMultiplosPeriodos.splice(idx, 1);
      },

      formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },

      parseDate (date) {
        if (!date) return null;

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
    }
  }
</script>
